import { Grid } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import { VehicleFiltersSchema } from 'core/schemas/vehicleFilters';
import { FormSubmitHandler } from 'Elements/Form';

import FilterVehicles from './FilterVehicles';
import VehiclesTable from './VehiclesTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

export default function Vehicles() {
  const [params, setParams] = useState({} as VehicleFiltersSchema);

  const onSubmit: FormSubmitHandler<VehicleFiltersSchema> = values => {
    setParams(serialize(values));
  };

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterVehicles onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Height100}>
        <VehiclesTable params={params} />
      </Grid>
    </Grid>
  );
}

const serialize = (values: any): any => {
  const params = JSON.parse(JSON.stringify(values));

  return params;
};
